"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleForemanPowerCircuitPhaseHeightFieldJoin = void 0;
var tslib_1 = require("tslib");
var field_join_ikecalc_1 = require("./field.join.ikecalc");
var POWER_CIRCUIT_PHASE_HEIGHTS = [
    'ipf_spanPowerCircuitPrimaryPhaseAHeight',
    'ipf_spanPowerCircuitPrimaryPhaseBHeight',
    'ipf_spanPowerCircuitPrimaryPhaseCHeight',
    'ipf_spanPowerCircuitSecondaryPhaseAHeight',
    'ipf_spanPowerCircuitSecondaryPhaseBHeight',
    'ipf_spanPowerCircuitSecondaryPhaseCHeight',
    'ipf_spanPowerCircuitShieldWireHeight',
    'ipf_spanPowerCircuitNeutralHeight'
];
var PoleForemanPowerCircuitPhaseHeightFieldJoin = /** @class */ (function (_super) {
    tslib_1.__extends(PoleForemanPowerCircuitPhaseHeightFieldJoin, _super);
    function PoleForemanPowerCircuitPhaseHeightFieldJoin(field) {
        var _this = _super.call(this, field) || this;
        _this.type = 'PoleForemanPowerCircuitPhaseHeightJoin';
        return _this;
    }
    PoleForemanPowerCircuitPhaseHeightFieldJoin.accepts = function (field) {
        return POWER_CIRCUIT_PHASE_HEIGHTS.indexOf(field.schema.id) > -1;
    };
    /**
     * Check if this field can join with another field by checking if they match framing and conductor types.
     * @param other - The other field to check.
     * @returns True if the field is a power circuit phase height field and matches the other field's framing and conductor types.
     */
    PoleForemanPowerCircuitPhaseHeightFieldJoin.prototype.joins = function (other) {
        var joinableHeight = this.getFieldValue(this.circuit, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        // Determine which field type this is
        var id = this.field.schema.id;
        var isPrimary = id.startsWith('ipf_spanPowerCircuitPrimary');
        var isSecondary = id.startsWith('ipf_spanPowerCircuitSecondary');
        var isShieldWire = id === 'ipf_spanPowerCircuitShieldWireHeight';
        var isNeutral = id === 'ipf_spanPowerCircuitNeutralHeight';
        // Use correct framing/conductor fields for matching
        var framingField = '';
        var conductorField = '';
        if (isPrimary) {
            framingField = 'ipf_spanPowerCircuitPrimaryFraming';
            conductorField = 'ipf_spanPowerCircuitPrimaryConductor';
        }
        else if (isSecondary) {
            framingField = 'ipf_spanPowerCircuitSecondaryFraming';
            conductorField = 'ipf_spanPowerCircuitSecondaryConductor';
        }
        else if (isShieldWire) {
            framingField = 'ipf_spanPowerCircuitShieldWireFraming';
            conductorField = 'ipf_spanPowerCircuitShieldWireConductor';
        }
        else if (isNeutral) {
            framingField = 'ipf_spanPowerCircuitNeutralFraming';
            conductorField = 'ipf_spanPowerCircuitNeutralConductor';
        }
        else {
            return false;
        }
        var framingType = this.getFieldValue(this.circuit, framingField);
        if (this.isDeadend(framingType)) {
            return false;
        }
        if (!other.circuit.hasField(id) || this.getFieldValue(other.circuit, id) != null) {
            return false;
        }
        return this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.circuit, other.circuit, framingField) &&
            this.fieldsEqual(this.circuit, other.circuit, conductorField) &&
            this.fieldsEqual(this.circuit, other.circuit, 'ipf_spanPowerCircuitType');
    };
    // Check if the spans are opposing (i.e., one is a fore span and the other is a back span)
    PoleForemanPowerCircuitPhaseHeightFieldJoin.prototype.spansOpposing = function (spanA, spanB) {
        if (spanA.instanceId === spanB.instanceId ||
            !spanA.hasField('ipf_spanType') ||
            !spanB.hasField('ipf_spanType')) {
            return false;
        }
        var spanAType = spanA.getField('ipf_spanType').value;
        var spanBType = spanB.getField('ipf_spanType').value;
        if (!spanAType || !spanBType) {
            return false;
        }
        var validTypes = ['fore_span', 'back_span', 'other'];
        if (validTypes.includes(spanAType) &&
            validTypes.includes(spanBType) &&
            spanAType !== spanBType) {
            return true;
        }
        return false;
    };
    return PoleForemanPowerCircuitPhaseHeightFieldJoin;
}(field_join_ikecalc_1.IkeCalcFieldJoin));
exports.PoleForemanPowerCircuitPhaseHeightFieldJoin = PoleForemanPowerCircuitPhaseHeightFieldJoin;
//# sourceMappingURL=field.join.poleforeman.powercircuit.js.map